export default __webpack_public_path__ + "static/media/feather-chevron-up.fd527911.svg";